<template>
    <div class="HowItWorks">
      <div class="title-box">
          <h1>{{$t('1108')}}</h1>
          <h3>{{$t('1162')}}</h3>
      </div>
      <div class="works-list">
        <ul>
          <li>
            <img src="@/assets/img/home6/work1.png" />
            <p>{{$t('1163')}}</p>
          </li>
          <li>
            <img src="@/assets/img/home6/work2.png" />
            <p>{{$t('1164')}}</p>
          </li>
          <li>
            <img src="@/assets/img/home6/work3.png" />
            <p>{{$t('1165')}}</p>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>
import { getCarousels } from "@/api";    
export default {
    data() {
        return {
       
        }
    },
    methods: {

    }
}    
</script>

<style lang="scss" scoped> 
.HowItWorks{
  margin-top: 40px;
  .title-box{
    h1{
      color: #fff;
    }
    h3{
      color: #8393AF;
      margin-top: 20px;
    }
  }
  .works-list{
    margin-top: 30px;
    ul{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li{
        width: 31%;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 24px;
        padding: 15px;
        img{
          width: 100%;
        }
        p{
          text-align: center;
          font-size: 16px;
          padding-bottom: 30px;
          padding-top: 15px;
          display: block;
          height: 100px;
        }
      }
    }
  }
}
@media screen  and (max-width: 1000px) {
  .works-list{
    ul{
      li{
        width: 100% !important;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 24px;
        padding: 15px;
        margin-top: 20px;
        img{
          width: 100%;
        }
        p{
          text-align: center;
          font-size: 16px;
          padding-bottom: 30px;
          padding-top: 15px;
          display: block;
          height: 100px;
        }
      }
    }
  }
}
</style>